import React from "react";
import errorSvg from "shared/assets/illustrations/03Page403.svg";
import "./systemError.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ErrorPage } from "@ds/ds-snam/react";


interface ISystemErrorProps {
    link:string
}
const SystemError: React.FC<ISystemErrorProps> = (props): JSX.Element => {
    const {link} = props;
    const {t} = useTranslation(['app']);
    const navigate = useNavigate();
    return (
        <>{/*<div id="systemErrorComponent" className="mainContainer">
            <img alt="illustration" src={errorSvg} />
            <div>
                <div className="title">
                    {t('errorPage.title')}
                </div>

                <div className="subtitle">{t('errorPage.subTitle')}</div>
                <p className="text">{t('errorPage.text')}</p>
                <div className="link" onClick={()=>{
                    navigate(link)
                }}>{t('errorPage.link')}
                </div>
            </div>
        </div>*/}
        <ErrorPage
            errorPageTitle={t('errorPage.title')}
            errorPageSubtitle="Oh no!"
            errorPageDescription={t('errorPage.subTitle')}
            errorPageImage={errorSvg}
            //errorPageImageAlt="Pagina non trovata"
            //errorPageLinkText="Ritorna alla home"
            errorPageLinkUrl="javascript:void(0)"
            //errorPageLinkIcon="icon-arrow-right"
            errorPageLinkIsExternal={false}
            errorPageLinkIsRouter={false}
            errorPageVariant="not-found"
            hasTextlinkAnimation={false}
            onClickLink={(event)=>{
                navigate(link)
            }}
        ></ErrorPage></>
    )
}

export default SystemError;